export class InstanceAssetType {
    instanceAssetTypeId: string;
    name: string;
}
